import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { useCreateProfileFieldStyles } from './field-styles'

export const SelectionCheckboxOption = ({
  checked,
  label,
  name,
  onChange,
  value,
}) => {
  const classes = useCreateProfileFieldStyles()

  return (
    <FormControlLabel
      className={classes.selectionCheckboxField}
      classes={{ label: classes.selectionCheckboxLabel }}
      control={
        <Checkbox
          checked={checked}
          color="default"
          onChange={onChange}
          size="small"
          classes={{
            root: classes.selectionCheckboxRoot,
            checked: classes.selectionCheckboxChecked,
          }}
        />
      }
      label={label}
      name={name}
      value={value}
    />
  )
}

SelectionCheckboxOption.propTypes = {
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export const SelectionCheckboxList = ({ children }) => {
  const classes = useCreateProfileFieldStyles()

  return <Box className={classes.selectionCheckboxList}>{children}</Box>
}

SelectionCheckboxList.propTypes = {
  children: PropTypes.node.isRequired,
}
